import { render, staticRenderFns } from "./RoltekBanner.vue?vue&type=template&id=05019aac&scoped=true"
import script from "./RoltekBanner.vue?vue&type=script&lang=js"
export * from "./RoltekBanner.vue?vue&type=script&lang=js"
import style0 from "./RoltekBanner.vue?vue&type=style&index=0&id=05019aac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05019aac",
  null
  
)

export default component.exports